import React, { useState } from 'react';

import LinkedIn from '@static/svg/linkedin.svg';
import CopyLink from '@static/svg/copy-link.svg';
import Facebook from '@static/svg/facebook.svg';
import Twitter from '@static/svg/twitter.svg';

import { popupCenter } from '@utils/creatorUtils';
const ShareIcon = ({ Icon, onClick }) => (
  <button
    onClick={onClick}
    type="button"
    className="w-8 h-8 m-2 p-1 flex justify-center items-center rounded-full border border-gray-600 border-solid"
  >
    <Icon className="w-5 h-5" />
  </button>
);

function SharePost({ slug }) {
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const sharePost = type => () => {
    const postUrl = `https://invideo.io${slug}`;
    switch (type) {
      case 'facebook': {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${postUrl}`;
        popupCenter(url);
        break;
      }
      case 'twitter': {
        const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          postUrl,
        )}`;
        popupCenter(url);
        break;
      }
      case 'linkedin': {
        const url = `https://www.linkedin.com/sharing/share-offsite/?url=${postUrl}`;
        popupCenter(url, 'Hey there', 550, 650);
        break;
      }
      case 'copylink': {
        if ('clipboard' in navigator) {
          navigator.clipboard.writeText(postUrl).then(() => {
            setIsLinkCopied(true);
          });
        }
        break;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <div className="flex items-center justify-center md:justify-end relative">
      <ShareIcon Icon={Facebook} onClick={sharePost('facebook')} />
      <ShareIcon Icon={Twitter} onClick={sharePost('twitter')} />
      <ShareIcon Icon={LinkedIn} onClick={sharePost('linkedin')} />
      <ShareIcon Icon={CopyLink} onClick={sharePost('copylink')} />
      {isLinkCopied && (
        <span className="text-sm absolute right-0 -bottom-5">Copied</span>
      )}
    </div>
  );
}

export default SharePost;
